import React from 'react';
import useRegearAdminLogic from './regearAdminLogic';
import '../../style/regearAdmin.scss';
import { MdDeleteForever } from 'react-icons/md';
import picUnavailable from '../../res/picUnavailable.png';
import getItemName from '../../utils/getItemName';
function RegearAdmin() {
  const { regearList, alert, noData, isLoading, deleteData, copyToClipboard, formatSilverValue } =
    useRegearAdminLogic();
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  if (regearList.length < 1) {
    return noData ? (
      <div className="noRegearsAtThisTime ">No regears at this time</div>
    ) : (
      <div className={`loading ${isLoading ? '' : 'hidden'}`}>
        <p>Loading</p>
      </div>
    );
  }
  return (
    <div className="regearAdmin">
      <div className={`copiedAlert ${alert ? 'fadeIn' : 'fadeOut'}`}>
        Copied to clipboard!
      </div>
      {regearList.map(doc => (
        <div key={doc[0]} className="cardContainer">
          <div className="cardVictimInfo">
            <p className="cardName">{doc[1].name} <span title='Death ID'>( {doc[1].deathId} )</span></p>
            <MdDeleteForever
              className="cardDeleteButton"
              onClick={() => deleteData(doc[0])}
            />
          </div>

          <div className="cardBattleInfo">
            <p className="battleDate">
              {monthNames[new Date(doc[1].date).getMonth()]}{' '}
              {new Date(doc[1].date).getDate()},{' '}
              {new Date(doc[1].date).getFullYear()}{' '}
            </p>
            <p className="battlePlayers">Players: {doc[1].players}</p>
          </div>
          <div className="headContainer">
            {doc[1].bag === null ? (
              <div title="No Bag" className="noItemContainer">
                <p className="noItem">No Bag</p>
              </div>
            ) : (
              <img
                alt={getItemName(doc[1].bag)}
                title={getItemName(doc[1].bag)}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = picUnavailable;
                }}
                src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${doc[1].bag}`}
              />
            )}
            {doc[1].head === null ? (
              <div title="No Helmet" className="noItemContainer">
                <p className="noItem">No Helmet</p>
              </div>
            ) : (
              <img
                alt={getItemName(doc[1].head)}
                title={getItemName(doc[1].head)}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = picUnavailable;
                }}
                src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${doc[1].head}`}
              />
            )}
            {doc[1].cape === null ? (
              <div title="No Cape" className="noItemContainer">
                <p className="noItem">No Cape</p>
              </div>
            ) : (
              <img
                alt={getItemName(doc[1].cape)}
                title={getItemName(doc[1].cape)}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = picUnavailable;
                }}
                src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${doc[1].cape}`}
              />
            )}
          </div>

          <div className="mainHand_armor_offHand">
            {doc[1].mainHand === null ? (
              <div title="No Weapon" className="noItemContainer">
                <p className="noItem">No Weapon</p>
              </div>
            ) : (
              <img
                alt={getItemName(doc[1].mainHand)}
                title={getItemName(doc[1].mainHand)}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = picUnavailable;
                }}
                src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${doc[1].mainHand}`}
                className="head"
              />
            )}

            {doc[1].armor === null ? (
              <div title="No Armor" className="noItemContainer">
                <p className="noItem">No Armor</p>
              </div>
            ) : (
              <img
                alt={getItemName(doc[1].armor)}
                title={getItemName(doc[1].armor)}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = picUnavailable;
                }}
                src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${doc[1].armor}`}
                className="armor"
              />
            )}

            {doc[1].offHand === null ? (
              <div title="No Off-Hand" className="noItemContainer">
                <p className="noItem">No Off-Hand</p>
              </div>
            ) : (
              <img
                alt={getItemName(doc[1].offHand)}
                title={getItemName(doc[1].offHand)}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = picUnavailable;
                }}
                src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${doc[1].offHand}`}
                className="offHand"
              />
            )}
          </div>
          <div className="shoes">
            {doc[1].shoes === null ? (
              <div title="No Shoes" className="noItemContainer">
                <p className="noItem">No Shoes</p>
              </div>
            ) : (
              <img
                alt={getItemName(doc[1].shoes)}
                title={getItemName(doc[1].shoes)}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = picUnavailable;
                }}
                src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${doc[1].shoes}`}
                className="shoes"
              />
            )}
          </div>
          <div className="extraInfoContainer">
            <div className="itemsLootedCount">
              Total Items Looted:{' '}
              {doc[1].inventory.filter(obj => obj != null).length}
            </div>
            <div className="itemValue" title={`${doc[1].itemValues &&`
Main-Hand: ${doc[1].itemValues[1] == null ? "No Data": "$"+formatSilverValue(doc[1].itemValues[1])}
Off-Hand: ${doc[1].itemValues[2] == null ? "No Data": "$"+formatSilverValue(doc[1].itemValues[2])}
Head: ${doc[1].itemValues[3] == null ? "No Data": "$"+formatSilverValue(doc[1].itemValues[3])}
Chest: ${doc[1].itemValues[4] == null ? "No Data": "$"+formatSilverValue(doc[1].itemValues[4])}
Feet: ${doc[1].itemValues[5] == null ? "No Data": "$"+formatSilverValue(doc[1].itemValues[5])}
Cape: ${doc[1].itemValues[6] == null ? "No Data": "$"+formatSilverValue(doc[1].itemValues[6])}
Mount: ${doc[1].itemValues[7] == null ? "No Data": "$"+formatSilverValue(doc[1].itemValues[7])}
                `}
              `}
            >
              $: {Number(doc[1].averageCost).toLocaleString()}
            </div>
            <div className="mount">
              {doc[1].mount ? (
                <img
                  alt={getItemName(doc[1].mount)}
                  title={getItemName(doc[1].mount)}
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = picUnavailable;
                  }}
                  src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${
                    doc[1].mount.split('@')[0]
                  }`}
                />
              ) : (
                'No Mount'
              )}
            </div>
          </div>

          <div className="chestPermsContainer">
            <textarea
              readOnly
              onClick={e => copyToClipboard(e.target.value)}
              className="chestPerms"
              value={`
              {
              "@_Owner" : "owner",
              "@_Guild" : "noaccess",
              "@_Everyone" : "noaccess",
              "Player:${doc[1].name}" : "coowner"
              }
              `}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default RegearAdmin;
